import React from 'react';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Philosophy } from './components/Philosophy';
import { Location } from './components/Location';
import { Footer } from './components/Footer';
import { OrganicDivider } from './components/OrganicDivider';
export function App() {
  return <div className="min-h-screen bg-cream" data-id="element-0">
      {/* Navigation - minimal, integrated into hero */}
      <header className="absolute top-0 left-0 right-0 z-50 px-6 py-6" data-id="element-1">
        <nav className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2">
          <a href="#" className="font-serif text-xl md:text-2xl font-medium text-botanical-text" data-id="element-3">
            Botanical
          </a>
          <div className="hidden md:flex items-center gap-8 font-sans text-sm" data-id="element-4">
            <a href="#services" className="text-botanical-muted hover:text-botanical-text transition-colors" data-id="element-5">
              Services
            </a>
            <a href="#philosophy" className="text-botanical-muted hover:text-botanical-text transition-colors" data-id="element-6">
              Philosophy
            </a>
            <a href="#location" className="text-botanical-muted hover:text-botanical-text transition-colors" data-id="element-7">
              Location
            </a>
            <a href="#location" className="px-5 py-2 bg-olive text-cream rounded-full hover:bg-olive-dark transition-colors" data-id="element-8">
              Book Now
            </a>
          </div>
          {/* Mobile menu button */}
          <button className="md:hidden p-2 text-botanical-text" aria-label="Open menu" data-id="element-9">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-10">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" data-id="element-11" />
            </svg>
          </button>
        </nav>
      </header>

      <main data-id="element-12">
        {/* Hero Section */}
        <Hero data-id="element-13" />

        {/* Organic divider: Cream to Sage */}
        <OrganicDivider variant="gentle" fillColor="fill-cream" className="-mt-1 bg-sage" data-id="element-14" />

        {/* Services Section */}
        <Services data-id="element-15" />

        {/* Organic divider: Sage to Cream */}
        <OrganicDivider variant="wave" fillColor="fill-sage" className="-mt-1 bg-cream" flip data-id="element-16" />

        {/* Philosophy Section */}
        <Philosophy data-id="element-17" />

        {/* Organic divider: Cream to Eucalyptus */}
        <OrganicDivider variant="curve" fillColor="fill-cream" className="-mt-1 bg-eucalyptus/30" data-id="element-18" />

        {/* Location Section */}
        <Location data-id="element-19" />

        {/* Organic divider: Eucalyptus to Footer */}
        <div className="bg-olive-dark" data-id="element-20">
          <OrganicDivider variant="gentle" fillColor="fill-eucalyptus/30" flip data-id="element-21" />
        </div>
      </main>

      {/* Footer */}
      <Footer data-id="element-22" />
    </div>;
}